<template>
    <div :class="!isMobile ? 'categories' : 'mobile-categories'">
        <ul>
            <li v-if="!isMobile"><a v-bind:class="{ active: currentCategory == 'all' }" @click="change('all')">Tüm Oyunlar</a></li>

            <li v-show="currentProvider == 'all' || (!_.isUndefined(categories[currentProvider]) && !_.isUndefined(categories[currentProvider]['blackjack']))" >
                <a v-bind:class="{ active: currentCategory == 'blackjack' }" @click="change('blackjack')">

                    Blackjack <slot v-if="!isMobile">Oyunları</slot>
                </a>
            </li>
            <li v-show="currentProvider == 'all' || (!_.isUndefined(categories[currentProvider]) && !_.isUndefined(categories[currentProvider]['roulette']))">
                <a  @click="change('roulette')" v-bind:class="{ active: currentCategory == 'roulette' }">
                    Rulet  <slot v-if="!isMobile">Oyunları</slot>
                </a>
            </li>
            <li v-show="currentProvider == 'all' || (!_.isUndefined(categories[currentProvider]) && !_.isUndefined(categories[currentProvider]['baccarat']))" >
                <a @click="change('baccarat')" v-bind:class="{ active: currentCategory == 'baccarat' }">
                    Baccarat  <slot v-if="!isMobile">Oyunları</slot>
                </a>
            </li>
            <li v-show="currentProvider == 'all' || (!_.isUndefined(categories[currentProvider]) && !_.isUndefined(categories[currentProvider]['hold']))" >
                <a href="javascript:;" @click="change('hold')" v-bind:class="{ active: currentCategory == 'hold' }">
                    Holdem  <slot v-if="!isMobile">Oyunları</slot>
                </a>
            </li>
            <li v-show="currentProvider == 'all' || (!_.isUndefined(categories[currentProvider]) && !_.isUndefined(categories[currentProvider]['other']))" >
                <a href="javascript:;" @click="change('other')" v-bind:class="{ active: currentCategory == 'other' }">
                    Diğerleri
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
  export default{
    computed:{
      categories(){
        return this.$store.getters['casino/getCategories'];
      },
      currentCategory(){
        return this.$store.getters['casino/getCurrentCategory'];
      },
      currentProvider(){
        return this.$store.getters['casino/getCurrentProvider'];
      },
    },
    methods:{
      change(provider){
        this.$emit('menuChange', 'games');
        if(provider == 'dropwins'){
          this.$store.dispatch('casino/changeProvider', ['pragmaticplay'])
        }
        this.$store.dispatch('casino/changeCategory', [provider])
      }
    }
  }
</script>